<div [formGroup]="parentForm">
  <wsd-extended-input label="{{ showLabel ? (label | translate) : '' }}"
                     [control]="parentForm.get(controlName)">
    <p-autoComplete [formControlName]="controlName"
                    placeholder="{{ showPlaceholder ? (placeholder | translate) : '' }}"
                    [suggestions]="organizations"
                    [ngClass]="(organizations[0]?.name?.length === 0)?'padding: 18px;':''"
                    [minLength]="1"
                    field="name"
                    [forceSelection]="true"
                    [dropdown]="true"
                    (completeMethod)="filterOrganizations($event)"
                    (onSelect)="onSelectValue($event)">
      <ng-template let-item pTemplate="item">
        <div [ngClass]="(item.name.length === 0)?'empty-string-autocomplete':''">
          {{item.name}}
        </div>
      </ng-template>
    </p-autoComplete>
  </wsd-extended-input>
</div>
